import { render, staticRenderFns } from "./Tzscrk.vue?vue&type=template&id=49b4adca&scoped=true&"
import script from "./Tzscrk.vue?vue&type=script&lang=js&"
export * from "./Tzscrk.vue?vue&type=script&lang=js&"
import style0 from "./Tzscrk.vue?vue&type=style&index=0&id=49b4adca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4adca",
  null
  
)

export default component.exports